import React, { useState, lazy, Suspense } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useScroll } from '../../../contexts/scroll';
import { useAuth } from '../../../contexts/auth';
import { useGlobal } from '../../../contexts/global';
import { useChat } from '../../../contexts/chat';
// import { useGlobal } from '../../../contexts/global';
import { POST_TYPES } from '../../../constants/constant';
// import Modal2 from '../../listing/Modal2';
const Modal2 = lazy(() => import('../../listing/Modal2')); // Adjust path if needed
import { useTranslation } from 'react-i18next';
import { sendMonitorNotif } from '../../../services/analyticsService';
import Hamburger from './Hamburger';

export const MobileTopNavigation = ({ isBannerVisible }: { isBannerVisible: boolean }) => {
  const { visible, isAtTop } = useScroll();
  const { messageCount } = useChat();
  const { isBusinessMode } = useGlobal();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const HandleCreatePost = (type: string) => {
    if (!currentUser) navigate('/login', { state: { redirectTo: location } });
    else {
      navigate(`/users/addpost/${type}`);
    }
  };

  const navStyle = `fixed top-${visible && isBannerVisible && isAtTop ? '12' : '0'}
     ${visible ? 'translate-y-0' : 'translate-y-[-48px]'}
    left-0 right-0 bg-white z-40 transition-all duration-300 items-center flex shadow-lg`;

  const MobileSearchBtn = () => {
    return (
      <Link to="/search">
        <img src="/images/icons/icon-mobile/mobile-search-button.svg" className="w-9 h-9 hidden" />
      </Link>
    );
  };

  const ModalItem = ({ itemLabel, onClick, imageUrl, haveFreeLabel }: any) => {
    return (
      <div
        className="flex gap-x-3 text-sm  py-4 sm:py-3 hover:bg-gray-100 hover:cursor-pointer items-center mx-4"
        onClick={onClick}
      >
        {imageUrl && (
          <img loading="eager" src={imageUrl} alt="ico" className="w-8 h-8 sm:w-8 sm:h-8" />
        )}
        <div className="flex items-center">
          <span>{t(itemLabel)}</span>
          {haveFreeLabel && <span className="text-deehiy font-bold text-xs pl-2">FREE</span>}
        </div>
      </div>
    );
  };

  const PlusModalContent = () => {
    return (
      <>
        <ModalItem
          haveFreeLabel={true}
          itemLabel="List property"
          onClick={() => {
            sendMonitorNotif({
              type: 'CREATE-LISTING',
              source: 'PLUS + MENU',
              userId: currentUser?.id,
            });
            navigate(`/create-property/${isBusinessMode ? '1' : ''}`);
          }}
          imageUrl="/images/icons/list-property-round.svg"
        />
        <ModalItem
          haveFreeLabel={true}
          itemLabel="Hunt property"
          onClick={() => {
            sendMonitorNotif({
              type: 'CREATE-HUNT',
              source: 'PLUS + MENU',
              userId: currentUser?.id,
            });
            navigate(`/hunting-board/create-hunt/${isBusinessMode ? 'business' : 'user'}`);
          }}
          imageUrl="/images/icons/hunt-property.svg"
        />
        {!isBusinessMode && (
          <>
            <ModalItem
              itemLabel="New post"
              onClick={() => HandleCreatePost(POST_TYPES.GENERAL)}
              imageUrl="/images/icons/new-post.svg"
            />
            <ModalItem
              itemLabel="Start discussion"
              onClick={() => HandleCreatePost(POST_TYPES.DISCUSSION)}
              imageUrl="/images/icons/new-discussion.svg"
            />
            <ModalItem
              itemLabel="Write article"
              onClick={() => HandleCreatePost(POST_TYPES.ARTICLE)}
              imageUrl="/images/icons/new-article.svg"
            />
          </>
        )}
      </>
    );
  };

  const PlusRoundBtn = () => {
    return (
      <img
        title={t('Create listings, posts and hunts')}
        src="/images/icons/deehiy-plus.svg"
        className="w-9 h-9"
        onClick={() => setShowModal(true)}
      />
    );
  };
  const MessengerdBtn = () => {
    const appToken = localStorage.getItem('@App:token');

    return (
      <Link
        to=""
        onClick={() =>
          window.open(`${import.meta.env.VITE_MESSENGER_URL}?token=${appToken}`, '_blank')
        }
        className="flex items-center justify-center relative"
      >
        <img src="/images/icons/deehiy-messenger-logo-headerbar.svg" className="w-9 h-9" />
        {messageCount > 0 && <span className="red-dot">{messageCount}</span>}
      </Link>
    );
  };

  return (
    <nav className={`${navStyle} h-12 `} aria-label="Main menu">
      <div className="mx-auto z-20 px-4 sm:px-20 w-full">
        <div className="flex items-center justify-between">
          <div className="w-1/3">
            <div className="flex items-center" onClick={() => (window.location.href = '/')}>
              <img src="/images/logo.jpg" className=" h-7 sm:h-9 " alt="Logo" />
            </div>
          </div>
          <div className="flex w-2/3 justify-end gap-x-6">
            <MobileSearchBtn />
            <PlusRoundBtn />
            <MessengerdBtn />
            <div className="pt-3">
              <Hamburger />
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<div className="p-4 text-sm">Loading modal...</div>}>
        <Modal2 showModal={showModal} setShowModal={setShowModal}>
          <PlusModalContent />
        </Modal2>
      </Suspense>
    </nav>
  );
};
